import { TravelerRole } from '~/models/Traveler'
import { BaseRepository } from '~/passporter-services/baseRepository'
import { ItineraryRepository } from '~/passporter-services/itinerary/repository'
import { ApiInvitation } from './apiTypes'
import { TripInvitationEntityMapper } from './entityMapper'
import { TRIP_INVITATION_STATUS, TripInvitation } from '~/models/TripInvitation'

export class InvitationRepository extends BaseRepository {
	static resource = 'v1/itineraries'

	static async acceptInvitation(itineraryId: string, code: string): Promise<void> {
		await this.post(`${this.resource}/${itineraryId}/travelers/accept_invitation/`, { code })
		ItineraryRepository.clearTripsCache()
	}

	static async generateInvitation(
		itineraryId: string,
		role?: TravelerRole,
		email?: string
	): Promise<TripInvitation> {
		const response: ApiInvitation | undefined = await this.post(
			`${this.resource}/${itineraryId}/travelers/invite/`,
			{ role, email }
		)
		return TripInvitationEntityMapper.toTripInvitation(response!)
	}

	static async getInvitations(itineraryId: string): Promise<TripInvitation[]> {
		const response: ApiInvitation[] = await this.get(`${this.resource}/${itineraryId}/invitations/`)
		return TripInvitationEntityMapper.toTripInvitations(response)
	}

	static async updateInvitation(
		itineraryId: string,
		invitationId: string,
		status: TRIP_INVITATION_STATUS
	): Promise<TripInvitation> {
		const response: ApiInvitation | undefined = await this.patch(
			`${this.resource}/${itineraryId}/invitations/${invitationId}/`,
			{ status }
		)
		return TripInvitationEntityMapper.toTripInvitation(response!)
	}
}
